import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'Report/BuyList', method: 'POST', body: filter, token: token })
}
